import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';

import { SeoInput, SeoService } from '../services/seo.service';

/**
 * Resolver global de SEO. Lee `route.data.seo` (estático por ruta) y aplica
 * `SeoService.apply()` ANTES de activar el componente. Esto garantiza que el
 * HTML SSR ya lleve `<title>`, meta description, OG/Twitter tags y canonical
 * en la primera respuesta — sin esperar hidratación.
 *
 * Para datos dinámicos (ficha de producto, catálogo por categoría con nombre
 * que viene del API, búsqueda con `q` del query param), el componente puede
 * llamar `SeoService.apply()` directamente cuando los datos llegan: la
 * segunda llamada sobreescribe los tags estáticos del resolver.
 *
 * El resolver computa además un `canonical` por defecto a partir de la URL
 * activa si la ruta no especificó uno explícito.
 */
export const seoResolver: ResolveFn<boolean> = (route, state) => {
  const seo = inject(SeoService);
  const input = (route.data?.['seo'] as SeoInput | undefined) ?? {};
  const canonical = input.canonical ?? state.url.split('?')[0];
  seo.apply({ ...input, canonical });
  return true;
};
